import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import moment from 'moment';

function WalmartPalletLabelsForm(props) {

    const [searchValue, setSearchValue] = useState("");
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    const handleSubmit = (event) => {
        event.preventDefault();

        if (startDate && endDate) {
            props.getBulkOrderInfo({
                start_date: startDate.format("YYYY-MM-DD"),
                end_date: endDate.format("YYYY-MM-DD")
            });

            return;
        }

        if (searchValue.trim()) {
            props.getBulkOrderInfo({
                order_number: searchValue.trim()
            });

            return;
        }

        props.toast?.error("Enter an order number or select a date range.");
    };

    return (
        <Box
            className={props.isMobile ? "mobile-box" : "desktop-box"}
            display="flex"
            flexDirection="column"
        >
            <form onSubmit={handleSubmit}>

                <Stack direction="row" alignItems="center">
                    <FormControl sx={{ width: '30%', mr: '10px' }}>
                        <TextField
                            label="PO Number or Sales Order Number"
                            value={searchValue}
                            onChange={(event) => setSearchValue(event.target.value)}
                        />
                    </FormControl>
                </Stack>

                <Stack
                    direction="row"
                    alignItems="center"
                    sx={{ mt: '20px' }}
                >
                    <FormControl sx={{ width: '20%', mr: '10px' }}>
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                            <DesktopDatePicker
                                label="Start Date"
                                value={startDate}
                                onChange={(value) => setStartDate(value)}
                                slotProps={{
                                    textField: {
                                        fullWidth: true
                                    }
                                }}
                            />
                        </LocalizationProvider>
                    </FormControl>

                    <FormControl sx={{ width: '20%', mr: '10px' }}>
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                            <DesktopDatePicker
                                label="End Date"
                                value={endDate}
                                onChange={(value) => setEndDate(value)}
                                slotProps={{
                                    textField: {
                                        fullWidth: true
                                    }
                                }}
                            />
                        </LocalizationProvider>
                    </FormControl>

                    <Button
                        type="submit"
                        disabled={props.isLoading}
                        variant="contained"
                        color="success"
                    >
                        Search
                    </Button>
                </Stack>

            </form>
        </Box>
    );
}

export default WalmartPalletLabelsForm;